// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-toggle="nav-mobile"]').on('click', (event) => {
  event.preventDefault();
  const $toggle = $(event.currentTarget);
  const $nav = $('.mobile-nav');
  const isVisible = $nav.hasClass('mobile-nav--visible');

  $toggle.toggleClass('hamburger--active');
  $nav.toggleClass('mobile-nav--visible');
  $nav.scrollTop(0);
  $('body, html').toggleClass('nav-mobile-is-visible');

  if (!isVisible) {
    // Restore container visibility for opening
    $nav.find('.full-nav-container').css('opacity', 1);

    // Hide items immediately
    const $items = $nav
      .find('.full-nav-container ul > li')
      .not('.sub-menu > li');
    $items.css({
      opacity: 0,
      transform: 'translateX(30px)'
    });

    // Wait for menu to fully open before animating items
    setTimeout(() => {
      $items.each((i, el) => {
        $(el)
          .delay(i * 120)
          .animate(
            { opacity: 1 },
            {
              duration: 400,
              step: (now, fx) => {
                if (fx.prop === 'opacity') {
                  $(el).css('transform', `translateX(${30 - now * 30}px)`);
                }
              }
            }
          );
      });
    }, 400);
  } else {
    // Fade out content quickly on close
    $nav.find('.full-nav-container').animate({ opacity: 0 }, 150);

    // Reset all submenus and carets
    $nav.find('.sub-menu').removeClass('sub-menu--visible');
    $nav.find('.caret').removeClass('fa-angle-up').addClass('fa-angle-down');
    $nav.find('li.menu-item').removeClass('menu-open');
    $nav.find('.main-nav').removeClass('has-open-submenu');
  }
});

// Top-level items with submenus should toggle submenu instead of navigating
$('.mobile-nav .main-nav > ul > li.menu-item-has-children > a.nav-menu-link').on('click', (event) => {
  event.preventDefault();
  $(event.currentTarget).siblings('.caret').trigger('click');
});

// Toggle nested menu items
$('.mobile-nav .caret').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  const $menuItem = $this.closest('li.menu-item');
  const $mainNav = $this.closest('.main-nav');
  const $siblingItems = $menuItem.siblings('li.menu-item');

  // Close any open siblings at the same level
  $siblingItems.find('.sub-menu').removeClass('sub-menu--visible');
  $siblingItems
    .find('.caret')
    .removeClass('fa-angle-up')
    .addClass('fa-angle-down');
  $siblingItems.removeClass('menu-open');

  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this.removeClass('fa-angle-down').addClass('fa-angle-up');
    $menuItem.addClass('menu-open');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this.removeClass('fa-angle-up').addClass('fa-angle-down');
    $menuItem.removeClass('menu-open');
  }

  // Toggle scrollable class based on any open submenus
  if ($mainNav.find('.sub-menu--visible').length > 0) {
    $mainNav.addClass('has-open-submenu');
  } else {
    $mainNav.removeClass('has-open-submenu');
  }
});

// Toggle nested menu items in footer
$('.mobile-nav__footer .page_item a').on('click', (event) => {
  event.preventDefault();
  const $this = $(event.currentTarget);
  if (!$this.siblings('.sub-menu').hasClass('sub-menu--visible')) {
    $this.siblings('.sub-menu').addClass('sub-menu--visible');
    $this
      .siblings('.caret')
      .removeClass('fa-angle-down')
      .addClass('fa-angle-up');
  } else {
    $this.siblings('.sub-menu').removeClass('sub-menu--visible');
    $this
      .siblings('.caret')
      .removeClass('fa-angle-up')
      .addClass('fa-angle-down');
  }
});
